// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"165":"organisation","417":"researcher","981":"researchGroup"}[chunkId] + "." + {"165":"351b06cc","417":"8c1dc2d7","981":"351b06cc"}[chunkId] + ".css";
};